import React, { useImperativeHandle, forwardRef, useState, useRef, useEffect, useMemo } from "react"
import { Card, CardBody, Col, Container, Row, DropdownToggle, DropdownItem, DropdownMenu, } from "reactstrap";
import { CascadeSelect } from 'primereact/cascadeselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import { InputText } from 'primereact/inputtext';

import { Dropdown } from 'primereact/dropdown';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { Calendar } from 'primereact/calendar';

import { InputTextarea } from 'primereact/inputtextarea';
import axios from "axios";
import { Toast } from "primereact/toast"
const LinkJobs = forwardRef(({ selectedCandidates, linkJobs, refreshCandidates, clearSelectedCandidates, onlyChangeStatus, selectedCandidateStatus}, ref) => {

  // link jobs 
  const toast = useRef(null)
  const [selectedLinkJob, setSelectedLinkJob] = useState(null);
  const [visibleLinkJob, setVisibleLinkJob] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobsTotalRecords, setJobsTotalRecords] = useState(0);
  const [jobsLazyParams, setJobsLazyParams] = useState({ page: 0, rows: 5 });
  const [jobsSearchText, setJobsSearchText] = useState("");
  const [jobsLoading, setJobsLoading] = useState(false);

  const [visiblePotentialJob, setVisiblePotentialJob] = useState(false);
  const [visibleSubmittedJob, setVisibleSubmittedJob] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [stages, setStages] = useState([]);
  const [currentStage, setCurrentStage] = useState("");
  const [visibleDialog, setVisibleDialog] = useState(false);
  const [selectedCandidatesList, setSelectedCandidatesList] = useState([]);
  const [uniqueUserId, setUniqueUserId] = useState("");

  const moreoptions = onlyChangeStatus ? [
    {
      name: 'Change Status',
      onClick: () => setChangeStatusAction(true)
    }
  ] : [
    {
      name: "Link Jobs",
      jobs: stages.map((stage) => ({
        name: stage.name,
        onClick: () => {
          if (selectedCandidates?.length === 0) {
            toast.current.show({ severity: 'info', summary: 'Info', detail: "Please select at least one candidate" });
            return
          } else {
            setCurrentStage(stage.name);
            setVisibleDialog(true);
          }
        },
      })),
    },
    {
      name: 'Change Status',
      onClick: () => setChangeStatusAction(true)
    },
    {
      name: 'Merge',
      onClick: () => mergeCandidate()
    }
  ];
  
  useImperativeHandle(ref, () => ({
    openAttachments: (stageName) => {
      if (!selectedCandidates || selectedCandidates.length === 0) {
        toast.current.show({
          severity: "warn",
          summary: "Warning",
          detail: "Please select at least one candidate",
        });
        return;
      }

      setCurrentStage(stageName);
      setVisibleDialog(true);
    },
      openChangeStatus: (initialStatus = "Applied") => {
    setStatus(initialStatus);
    setChangeStatusAction(true);
  },
    openMerge: () => mergeCandidate(true)
  }));

  const [candidateName, setCandidateName] = useState("Lavankumar Kalvala, Venkata Laxmi Valle");
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [userId, setUserId] = useState();
  const [subject, setSubject] = useState("");
  const [notes, setNotes] = useState("");

  const [selectedJobs, setSelectedJobs] = useState([]);


  const [searchText, setSearchText] = useState('');
  const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
  const [selectedJobTitles, setSelectedJobTitles] = useState('');

  const handleIconClick = () => {
    setJobDetailsVisible(true);
  };

  const handleSave = () => {
    const selectedJobTitles = selectedJobs.map((job) => job.job_title).join(", ");
    setSelectedJobTitles(selectedJobTitles);
    setJobDetailsVisible(false);
  };


  const handleRefresh = () => {
    setSelectedJobs([]);
    setSearchText('');
  };


  // link jobs

  const [changeStatusAction, setChangeStatusAction] = useState(false)
  const [Status, setStatus] = useState(selectedCandidateStatus)

  const changeStatusofCandidate = async () => {
    const candidateIds = selectedCandidates.map(candidate => candidate.value.candidate);
    if (candidateIds.length === 0) {
      // triggerAlert('warning', 'Warning', 'Please select at least one candidate.');
      toast.current.show({ severity: 'error', summary: 'Warning', detail: `Please select at least one candidate` });
    } else {
      const req = { status: Status }
      try {
        const response = await axios.patch(`/api/v1/candidates/${candidateIds}/change-status/`, req, {});

        if (response.status === 200) {
          toast.current.show({ severity: 'success', summary: 'Success', detail: `Status changed successfully` });
          refreshCandidates();
        }
        // console.log("changestatus", response);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setChangeStatusAction(false);
      }
    }

  }

  const mergeCandidate = async () => {
    setIsLoading(true);
    try {
      const candidateIds = selectedCandidates.map(c => c.value.candidate || c.value.id || c.value);

      if (!candidateIds || candidateIds.length < 2) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'You must provide at least two candidate IDs.',
        });
        setIsLoading(false);
        return;
      }

      const payload = { candidate_ids: candidateIds };

      const response = await axios.post(`/api/v1/candidates/merge-candidates/`, payload);

      if (response.status === 200 || response.status === 201) {
        toast.current.show({ severity: 'success', summary: 'Merge', detail: "Merged successfully" });
        refreshCandidates();
        if (clearSelectedCandidates) clearSelectedCandidates(); // <-- Uncheck after merge
      }
    } catch (error) {
      console.error('Submission error', error);
    } finally {
      setIsLoading(false);
    }
  };
  // Fetch stages
  const fetchStages = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-stages/");
      if (response.data && response.data.results) {
        setStages(response.data.results);
      }
    } catch (error) {
      console.error("Error fetching stages:", error);
    }
  };

  useEffect(() => {
    fetchStages();
  }, []);

  useEffect(() => {
    if (selectedCandidateStatus) {
      setStatus(selectedCandidateStatus);
    }
  }, [selectedCandidateStatus]);



  const onSubmitlinkJobs = async () => {
    if (selectedJobs.length === 0) {
      toast.current.show({ severity: "warn", summary: "Warning", detail: "Please select at least one job" });
      return;
    }


    const jobIds = selectedJobs.map((job) => job.job_id).join(",");

    const req = {
      job_id: jobIds,
      candidate: selectedCandidates?.map((candidate) => candidate.value),
      status: "Active",
      notes: notes,
      subject: subject,
      user_ids: uniqueUserId,
      applied_date: currentDateTime.toISOString(),
      stage: currentStage,
    };

    try {
      const response = await axios.post(`/api/v1/candidate-job-links/?job_id=${jobIds}`, req);
      if (response.status === 201) {
    setVisibleDialog(false);
    toast.current.show({ severity: "success", summary: "Success", detail: "Jobs linked successfully" });
      // Show grouped warning toast for skipped candidates
      if (response.data.skipped && Array.isArray(response.data.skipped) && response.data.skipped.length > 0 && toast && toast.current) {
        const skippedNames = [...new Set(response.data.skipped.map(c => c.candidate_name))].join(", ");
        toast.current.show({ severity: 'warn', summary: 'Skipped Candidates', detail: `${skippedNames} skipped`, life: 6000 });
      }
    setSelectedJobs([]);
    setSelectedJobTitles("");
    setSubject("");
    setNotes("");
    refreshCandidates();
  } else {
    setVisibleDialog(false);
    toast.current.show({ severity: "warn", summary: "Warning", detail: response.data?.detail || "Candidate already linked to this job." });
    setSelectedJobs([]);
    setSelectedJobTitles("");
    setSubject("");
    setNotes("");
    return;
  }
    } catch (error) {
      console.error("Error linking jobs:", error);
      setVisibleDialog(false);
      toast.current.show({ severity: "error", summary: "Error", detail: "Failed to link jobs" });
    }
  };
  // console.log("linkJobs", linkJobs);

  useEffect(() => {
    const userInfo = JSON.parse(sessionStorage.getItem("user-info"));
    if (userInfo && userInfo.user_details) {
      setUniqueUserId(userInfo.user_details.unique_user_id);
    }
  }, []);

    const fetchJobs = async (page = 0, rows = 5) => {
    setJobsLoading(true);
    try {
      let endpoint = `/api/v1/jobs/?page=${page + 1}&size=${rows}&status=Approved / Open`;
      const response = await axios.get(endpoint);
      setJobs(response.data.results || []);
      setJobsTotalRecords(response.data.count || 0);
    } catch (error) {
      setJobs([]);
      setJobsTotalRecords(0);
    } finally {
      setJobsLoading(false);
    }
  };

  useEffect(() => {
    if (jobDetailsVisible) {
      fetchJobs(jobsLazyParams.page, jobsLazyParams.rows);
    }
  }, [jobDetailsVisible, jobsLazyParams]);
    const filteredJobs = jobs.filter(job => {
    const search = jobsSearchText.toLowerCase().trim();
    return (
      (job.job_title && job.job_title.toLowerCase().includes(search)) ||
      (job.job_number && job.job_number.toString().toLowerCase().includes(search)) ||
      (job.hiring_manager_name && job.hiring_manager_name.toLowerCase().includes(search))
    );
  });
    const onJobsPageChange = (event) => {
    setJobsLazyParams({ page: event.page, rows: event.rows });
  };

  // Search input handler
  const onJobsSearchInput = (e) => {
    setJobsSearchText(e.target.value);
    setJobsLazyParams(prev => ({ ...prev, page: 0 })); // Reset to first page on search
  };
  
  
  return (
    <React.Fragment>
      <Toast ref={toast} />
      <CascadeSelect
        // value={selectedLinkJob}
        onChange={(e) => {
          setSelectedLinkJob(e.value);
          if (e.value && e.value.onClick) {
            e.value.onClick(); // Trigger the onClick of selected job (e.g. 'Received')
          }
        }}
        options={moreoptions}
        optionLabel="name"
        optionGroupLabel="name"
        optionGroupChildren={['jobs']}
        className="md:w-8rem"
        breakpoint="767px"
        placeholder="More"
      />
      <Dialog
        header={`Link Candidates as ${currentStage}`}
        visible={visibleDialog}
        onHide={() => setVisibleDialog(false)}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        className="link-candidates"
      >
        <Row>
          <Col lg={6}>
            <div className="field">
              <label htmlFor="candidate" className="block mb-0">
                Candidates
              </label>
              <InputText
                id="job"
                value={selectedCandidates.map((candidate) => candidate.label).join("| ")}
                placeholder="Enter Candidate"
                className="w-full"
                style={{ paddingRight: "2rem" }}
                disabled
              />

            </div>
          </Col>
          <Col lg={6}>
            <div className="field">
              <label htmlFor="job" className="block mb-0">Job</label>
              <div className="d-flex align-items-center" style={{ position: "relative" }}>
                <InputText
                  id="job"
                  value={selectedJobTitles}
                  onChange={(e) => setSelectedJobTitles(e.target.value)}
                  placeholder="Enter Job"
                  className="w-full"
                  style={{ paddingRight: "2rem" }}
                />
                <i
                  className="pi pi-chevron-down"
                  onClick={handleIconClick}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                ></i>
              </div>
               <Dialog
      header="Job Details"
      visible={jobDetailsVisible}
      onHide={() => { setJobDetailsVisible(false); setSelectedJobs([]) }}
      style={{ width: "40vw" }}
      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      className="cand-details"
    >
      {/* Search Bar */}
      <Row>
        <Col lg={12}>
          <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
            <InputText
              placeholder="Search Jobs"
              value={jobsSearchText}
              onInput={onJobsSearchInput}
              style={{ paddingRight: "2rem" }}
            />
            <i
              className="pi pi-search"
              style={{
                position: "absolute",
                right: "10px",
                top: "49%",
                transform: "translateY(-50%)",
              }}
            ></i>
          </div>
        </Col>
      </Row>
      {/* DataTable */}
      <DataTable
        value={filteredJobs}
        paginator
        lazy
        loading={jobsLoading}
        rows={jobsLazyParams.rows}
        first={jobsLazyParams.page * jobsLazyParams.rows}
        totalRecords={jobsTotalRecords}
        onPage={onJobsPageChange}
        selection={selectedJobs}
        onSelectionChange={e => setSelectedJobs(e.value)}
        dataKey="job_id"
        rowsPerPageOptions={[5, 10, 25, 50]}
        size="small"
        emptyMessage={jobsLoading ? "Loading..." : "No jobs found."}
      >
        <Column selectionMode="multiple" style={{ width: "3em" }} />
        <Column field="job_number" header="Job ID" />
        <Column field="job_title" header="Job Title" />
        <Column field="hiring_manager_name" header="Contact" />
      </DataTable>
      {/* Actions */}
      <div className="d-flex mt-3">
        <button
          type="button"
          className="btn btn-primary me-2 btn-main"
          onClick={handleSave}
        >
          Ok
        </button>
        <button
          type="button"
          className="btn btn-primary btn-main"
          onClick={handleRefresh}
        >
          Refresh
        </button>
      </div>
    </Dialog>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <div className="field">
              <label htmlFor="currentDateTime" className="block mb-0">
                Date
              </label>
              <Calendar
                id="currentDateTime"
                value={currentDateTime}
                onChange={(e) => setCurrentDateTime(e.value)}
                showTime
                showIcon
                dateFormat="yy-mm-dd"
                hourFormat="12"
                disabled
                className="w-full"
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="field">
              <label htmlFor="userId" className="block mb-0">
                User IDs
              </label>
              <InputText
                id="userId"
                value={uniqueUserId}
                readOnly
                className="w-full"
                placeholder="User ID"
                disabled
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="field">
              <label htmlFor="subject" className="block mb-0">
                Subject
              </label>
              <InputText
                id="subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="w-full"
                placeholder="Enter subject"
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="field">
              <label htmlFor="notes" className="block mb-0">
                Notes
              </label>
              <InputTextarea
                id="notes"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                rows={3}
                cols={20}
                className="w-full"
                placeholder="Enter your notes here..."
                autoResize
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="d-flex justify-content-end">
              <button type="button" className="btn btn-primary me-2 btn-main" onClick={onSubmitlinkJobs}>
                Ok
              </button>
              <button
                className="btn btn-primary me-2 cancel-outlinebtn"
                onClick={() => setVisibleDialog(false)}
              >
                <i className="pi pi-times me-1"></i>
                Cancel
              </button>
            </div>
          </Col>
        </Row>
      </Dialog>


      <Dialog
        header="Change Status"
        visible={changeStatusAction}
        onHide={() => setChangeStatusAction(false)}
        style={{ width: '30vw' }}
        className="changestatus-popup"
        onShow={() => {
          const currentStatus = selectedCandidates[0]?.value?.status;
          setStatus(currentStatus);
        }}

      >
        {/* Search Bar */}
        <Row className="mt-2 align-items-center">
          <Col xl={2}>
            <label className="block mb-2"                                  >
              Status
            </label>
          </Col>
          <Col xl={10}>
            <div className="card flex justify-content-center mb-0 border-0">
              <select
                className='form-select profileDetailsInput' id="MyPro_EmpDet_Team_WorkInfo_DesSelBox"
                onChange={(e) => setStatus(e.target.value)}
                value={Status}
              >
                <option value='Active'>Active</option>
                <option value='InActive'>InActive</option>
                <option value='DND(Do Not Disturb)'>DND(Do Not Disturb)</option>
                <option value='Blacklisted'>Blacklisted</option>
                <option value='Opt-Out'>Opt Out</option>
              </select>
            </div>
          </Col>
        </Row>

        <div className="d-flex justify-content-end  mt-4">
          <button type="button" class="btn btn-primary btn-main" onClick={changeStatusofCandidate}>Submit</button>
        </div>
      </Dialog>

    </React.Fragment>
  );
});



export default LinkJobs;